<style lang="css">
/*出错模块*/
.error_box{ width:100%;text-align:center; padding:10% 0;}
.error_box>p{margin-top:0; display:block; font-size:60px;}
.error_box_img{ padding:15px 0;}
.error_box_img img{ display:block; max-width:80%; margin:0 auto;}
.error_box_txt{ font-size:16px; padding:10px 0 10px; color:#737373; display:inline-block;}

.err_400>p{ color:#ff7800; }
.err_404>p{ color:#27b0f2; }
.err_500>p{ color:#f0485f; }
.err_fix>p{ color:#27b0f2; font-size:25px; }
</style>
<template lang="html">
	<div class="container">
		<div class="error_box err_400" v-if="'400'==type">
			<p>400</p>
			<div class="error_box_img"><img src="./images/error_400.png"></div>
			<span class="error_box_txt">部分文件不存在</span>
		</div>

		<div class="error_box err_404" v-if="'404'==type">
			<p>404</p>
			<div class="error_box_img"><img src="./images/error_404.png"></div>
			<span class="error_box_txt">找不到资源，您请求的资源不存在</span>
		</div>

		<div class="error_box err_500"  v-if="'500'==type">
			<p>500</p>
			<div class="error_box_img"><img src="./images/error_500.png"></div>
			<span class="error_box_txt">系统错误 - 服务器端出错，请稍后再试。如果重复出现此页面，请与网站管理员联系</span>
		</div>

		<div class="error_box err_fix" v-if="'fix'==type">
			<p>系统正在维护...</p>
			<div class="error_box_img"><img src="./images/error_fix.png"></div>
			<span class="error_box_txt">请耐心等候...</span>
		</div>

		<div class="error_box err_500"  v-if="'403'==type">
			<p>403</p>
			<div class="error_box_img"><img src="./images/error_500.png"></div>
			<span class="error_box_txt">没有访问权限，请与网站管理员联系</span>
		</div>
	</div>
</template>

<script>
export default {
	props : {
		type: {
			type: String,
			required: true
		}
	},
	data : function(){
		return{};
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/error/Error.vue